import { inject, observer } from "mobx-react";
import React from "react";
import { Trans, TransProps, useTranslation } from "react-i18next";
import { Log } from "src/models";
import { LogStore } from "src/stores";

export interface ILogTextProps {
  log:       Log;
  logStore?: LogStore;
}

export const LogText = inject("logStore")(observer((props: ILogTextProps) => {
  const { t, i18n } = useTranslation();
  const { logStore, log } = props;
  const [transProps, setTransProps] = React.useState<TransProps<any, "log">>(null);
  React.useEffect(() => {
    logStore.logParser.parse(log, true).then((props) => {
      log && setTransProps(props);
    });
  }, [log]);
  if(!log || !transProps) return <></> ;
  return <Trans {...transProps} />;
}));